import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseMapComponent } from '@huge-monorepo/shared/components';
import { BaseMapLocation } from 'libs/shared/src/interfaces/BaseMapLocation';
import { ActivatedRoute } from '@angular/router';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { MatRadioChange } from '@angular/material/radio';
import { FormControl } from '@angular/forms';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { start } from 'repl';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import {
  IHIPTeltonikaService,
  ICustomerTeltonikaService,
  ServiceProviderMarkerIcon,
} from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'huge-monorepo-teltonika-device-location',
  standalone: true,
  imports: [CommonModule, BaseMapComponent, MaterialModule],
  templateUrl: './teltonika-device-location.component.html',
  styleUrl: './teltonika-device-location.component.scss',
})
export class TeltonikaDeviceLocationComponent implements OnInit, OnDestroy {
  teltonikaService = this.sharedTeltonikaService.getService();
  displayLocation: boolean = false;
  deviceLocations: BaseMapLocation[] = [];
  errorFetchingData: boolean = false;

  startDate: FormControl = new FormControl(null);
  endDate: FormControl = new FormControl(null);

  filterValue?: string | null = null;

  subscriptions: any[] = [];

  private id: number;
  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private route: ActivatedRoute,
    private tools: SharedToolsService) { }
  ngOnInit(): void {
    this.displayLocation = false;
    this.route.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          let id = paraMap.params.id;
          this.id = id;
          this.fetchLocationData(id);
        }
      }

    );

    const sub2 = this.endDate.valueChanges.subscribe((value) => {
      if (this.endDate.value != null && this.startDate.value != null) {
        this.fetchLocationData(this.id);
      }
    });
    this.subscriptions.push(sub2);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  fetchLocationData(id: number) {
    this.deviceLocations = [];
    this.errorFetchingData = false;
    this.displayLocation = false;
    const start = this.startDate.value != null ? this.tools.FormatStartDate(this.startDate.value.toISOString()) : null;
    const end = this.endDate.value != null ? this.tools.FormatEndDate(this.endDate.value.toISOString()) : null;
    this.teltonikaService.getDeviceLocations(id, this.filterValue, start, end).subscribe({
      next: (data) => {
        if (data == null) {
          this.displayLocation = true;
          return;
        }
        this.deviceLocations = data.map((location, i) => {
          let iconInfo: ServiceProviderMarkerIcon = this.tools.GetBasicTowerMarkerInfo(location.MNC, i == 0 ? 'c' : i == 1 ? 'p' : null)
          iconInfo.icon = 'assets/map-markers/' + iconInfo.icon;
          return {
            latitude: location.Lat,
            longitude: location.Lng,
            infoWindowContent: `
                <span>Sim Cell: ${location.SimCell}</span><br />
                <span>Sim Number: ${location.SimNum}</span><br />
                <span>Timestamp: ${this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(location.Timestamp))}</span><br />
                <span>LAC: ${location.LAC}</span><br />
                <span>Cell ID: ${location.CellID}</span><br />
                <span>MCC: ${location.MCC}</span><br />
                <span>MNC: ${location.MNC}</span><br />
                <span>Provider: ${this.tools.GetNetworkNameByMNC(location.MNC)}</span></span>`,
            customIcon: iconInfo,
          };
        });
        console.log(this.deviceLocations)
        this.displayLocation = true;
      },
      error: (error) => {
        console.error("Error in fetching location data: ", error);
        this.displayLocation = true;
        this.errorFetchingData = true;
      },
    });
  }

  filterChanged(event: MatRadioChange) {
    this.filterValue = event.source.value;
    this.fetchLocationData(this.id);
  }

}
